(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('HandbookVersion', HandbookVersion);

    HandbookVersion.$inject = ['$resource', 'DateUtils'];

    function HandbookVersion ($resource, DateUtils) {
        var resourceUrl =  'api/handbook-versions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.validFrom = DateUtils.convertDateTimeFromServer(data.validFrom);
                        data.validUntil = DateUtils.convertDateTimeFromServer(data.validUntil);
                        data.publicationDate = DateUtils.convertDateTimeFromServer(data.publicationDate);
                        data.creationTime = DateUtils.convertDateTimeFromServer(data.creationTime);
                        data.revisionTime = DateUtils.convertDateTimeFromServer(data.revisionTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
